import React from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField, withFormFieldGroupFormField } from '@gogame/form';

import { PLATFORMS } from 'scenes/Influencers/InfluencersCampaigns/components/InfluencerCampaignForm/constants';

import GGCampaignLink from './GGCampaignLink';
import { EXPIRATION_DATE, PLATFORM_ID } from './constants';
import { ggCampaignLinksSchema } from './schemas';

const getNameById = (list, targetId) =>
  list?.find(({ id }) => id === targetId)?.name;

const GGCampaignLinks = withFormFieldGroupFormField({
  schema: ggCampaignLinksSchema,
})(({ platforms, platformsAllList, isEdit }) => (
  <React.Fragment>
    <Section title={'GG Campaigns Links'}>
      {platforms.map(
        ({ [PLATFORM_ID]: platformId, trackingLink, ggLink }, index) => (
          <GGCampaignLink
            key={platformId}
            name={`${PLATFORMS}.${index}`}
            platformName={getNameById(platformsAllList, platformId)}
            isEdit={isEdit}
            trackingLink={trackingLink}
            ggLink={ggLink}
          />
        )
      )}
    </Section>
    <Section title={'GG Links Expiration Date'}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <FormField.DatePicker
            name={EXPIRATION_DATE}
            label={'Select date'}
            minDate={new Date()}
            padding={0}
          />
        </Grid>
      </Grid>
    </Section>
  </React.Fragment>
));

export default GGCampaignLinks;
